<app-dashboard-container
	class="dashboard-se-ce-verschil dashboard-cijfers"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(),permanentFilterExpressions,$event)"
>
	<app-filter-panel
		[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
			<app-weergave-optie label="Weergave" param="cijfersseceweergave" [value]="this.weergave()" [enum]="CijfersSeCeWeergave"></app-weergave-optie>
			<app-legenda
				class="cl-header-utility"
				[attribute]="weergave() === CijfersSeCeWeergave.VERSCHIL ? ['cf_fun_nr_cijferverschil_se_ce_afgerond'] : ['x_cijfer_ov']"
				[keyIsClassName]="weergave() === CijfersSeCeWeergave.VERSCHIL"
			></app-legenda>
		</app-dashboard-header>
		@for (w of [weergave]; track w) {
			<!-- Rerender de tabel bij wijziging van weergave -->
			@if (variant() === DashboardVariant.ACTUEEL) {
				<app-barchart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions"
					[groups]="groeperingService.huidigeGroeperingen()"
					[config]="this"
				></app-barchart-table>
			}
		}
		@if (variant() === DashboardVariant.HISTORIE) {
			<app-vbarchart-table
				[filters]="filterExpressions()"
				[permanentFilters]="permanentFilterExpressions"
				[groups]="historieGroups()"
				[subgroups]="historieSubgroups()"
				[batchLevels]="isHistorieBatchVariant() ? 1 : 0"
				[config]="this"
				[schooljaarPath]="['cf_nm_schooljaar']"
				[partitionMeasure]="partitionMeasure()"
				[options]="{ showPartitionRectangle: weergave() === 'SE-CE verschil' }"
			>
			</app-vbarchart-table>
		}
	</section>
</app-dashboard-container>
